import api from './api';

interface Chat {
  id: number;
  created_at: string;
  status: string;
  title: string;
  agent?: string | null;
}

interface ChatHistoryResponse {
  history: any[];
  status: string;
  last_history_id: number;
  agent?: string | null;
}

export interface StarterPrompt {
  id: string;
  text: string;
  icon: string;
  category: string;
}

export interface UserInfo {
  user_id: number;
  is_authenticated: boolean;
  name?: string | null;
  avatar?: string | null;
}

export interface ProcessedProduct {
  id: number;
  title: string;
  vendor: string;
  photo: string;
  price: number;
}

export interface ProcessedProductsResponse {
  products: ProcessedProduct[];
  total_count: number;
}

export const chatService = {
  async createChat(
    message: string,
    initialization: Record<string, any>,
    session_id: string,
    agent?: string | null
  ): Promise<Chat> {
    const { data } = await api.post<Chat>('/api/chatbot/chats', { message, initialization, session_id, agent });
    return data;
  },

  async fetchChats(limit = 10): Promise<Chat[]> {
    const { data } = await api.get<Chat[]>('/api/chatbot/chats', {
      params: { limit }
    });
    return data;
  },

  async deleteChat(chatId: number): Promise<void> {
    await api.delete(`/api/chatbot/chats/${chatId}`);
  },

  async fetchChatHistory(chatId: number, afterId?: number): Promise<ChatHistoryResponse> {
    const { data } = await api.get<ChatHistoryResponse>(`/api/chatbot/chats/${chatId}/history`, {
      params: afterId ? { after_id: afterId } : {}
    });
    return data;
  },

  async sendMessage(chatId: number, message: string): Promise<void> {
    await api.post(`/api/chatbot/chats/${chatId}/messages`, null, {
      params: { message }
    });
  },

  async fetchStarterPrompts(): Promise<StarterPrompt[]> {
    const { data } = await api.get<StarterPrompt[]>('/api/chatbot/starter-prompts');
    return data;
  },

  async getUserInfo(): Promise<UserInfo> {
    const { data } = await api.get<UserInfo>('/api/chatbot/user/info');
    return data;
  },

  async fetchProcessedProducts(chatId: number): Promise<ProcessedProductsResponse> {
    const { data } = await api.get<ProcessedProductsResponse>(`/api/chatbot/chats/${chatId}/processed-products`);
    return data;
  }
};
